import { render, staticRenderFns } from "./join_1.vue?vue&type=template&id=d67a96d4&"
import script from "./join_1.vue?vue&type=script&lang=js&"
export * from "./join_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports